import React, { useEffect, useContext } from "react";

import { trackPurchase } from "../DonationTool/utils";
import { RedirectReceiptPageContext } from "./RedirectReceiptPageProvider";
import LoyaltyCampaign from "../LoyaltyCampaign";
import EntryNumbers from "./EntryNumbers";
import Layout from "../Layout";
import Share from "../Share";
import Money from "../Money";
import usePollQuery from "../../lib/usePollQuery";
import { isBlank } from "../../lib/presence";
import { receiptQuery } from "./gql";
import DonationCard from "./DonationCard";
import PrintButton from "../PrintButton";

import * as UI from "./ui";

const Receipt = () => {
  const { paymentIntent, paymentMethod, donationId, sweepstakes, promoCodeName } = useContext(RedirectReceiptPageContext);
  const { data, timedOut } = usePollQuery(receiptQuery, {
    variables: { id: donationId },
    testPath: ['receipt', 'ticketRanges'],
    pollInterval: 500,
    pollTimeout: 5000,
  });
  const { receipt } = data || {};

  useEffect(() => {
    if (isBlank(receipt)) {
      return;
    }

    trackPurchase({
      paymentIntent,
      paymentMethod,
      donationLevel: receipt.donationLevel,
      promoCode: promoCodeName ? { name: promoCodeName } : null,
      sweepstakes,
    });
  }, [receipt, paymentIntent, paymentMethod, promoCodeName, sweepstakes]);

  if (isBlank(receipt)) {
    return (
      <Layout.FullWidth fold id="receipt">
        <Layout.FullWidthColumn>
          {timedOut ? (
            <>
              <UI.Heading>Thank you for your donation</UI.Heading>
              <UI.Message>
                Thanks for your patience. Processing your donation is taking longer than expected. Don’t worry, you’ll receive an email with your entry numbers.
                For more help, please contact us: <a href="mailto:support@tapkat.com">support@tapkat.com</a>
              </UI.Message>
            </>
          ) : (
            <>
              <UI.Heading>Thank you for your donation</UI.Heading>
              <UI.Message>
                Thank you for donating. Just a sec while we process your donation...
              </UI.Message>
            </>
          )}
        </Layout.FullWidthColumn>
      </Layout.FullWidth>
    );
  }

  return (
    <Layout.FullWidth fold id="receipt">
      <PrintButton position="header" />
      <Layout.FullWidthColumn>
        <UI.Heading>Thank you for your donation</UI.Heading>
      </Layout.FullWidthColumn>
      <Layout.FixedColumn span={5} breakpoint="belowTablet" style={{position: "relative"}}>
        <DonationCard donationLevel={receipt.donationLevel} promoTickets={receipt.promoCodeTicketCount} donor={receipt.donor} />
        <PrintButton position="card" />
      </Layout.FixedColumn>
      <Layout.FlexibleColumn span={[7,15]} breakpoint="belowTablet" spaced>
        <LoyaltyCampaign sweepstakes={sweepstakes} donor={receipt.donor} />
        <UI.ThankYou>
          Thank you for your donation!
        </UI.ThankYou>
        <EntryNumbers receipt={receipt} />
        <UI.Message>
          We sincerely appreciate your support of {sweepstakes.nonprofit.name}, EIN {sweepstakes.nonprofit.ein}.
          A donation receipt including your official sweepstakes entries has been emailed to you.
          Please print your email receipt and keep it in a safe place.
          Your sweepstakes entries have been placed in the official sweepstakes entry pool.
        </UI.Message>

        <UI.ShareCTA>Please share your donation with your friends and help support our cause.</UI.ShareCTA>
         <Share receipt />
        <UI.HiddenAmount id="receipt-amount">
          <Money cents={receipt.donationLevel.price} format="0.00" />
        </UI.HiddenAmount>
      </Layout.FlexibleColumn>
    </Layout.FullWidth>
  );
};

export default Receipt;
